import { ConfigActionTypes, IConfigData } from './types';

export function setConfig(config: IConfigData) {
  return {
    type: ConfigActionTypes.SET_CONFIG,
    payload: config,
  };
}
